import Alert from "@mui/material/Alert";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React from "react";
import { API_BASE, ADMIN_OPS, requestJson } from "../utils";
import { useSearchParams } from "react-router-dom";
import LatestBpmJob from "../components/LatestBpmJob";
import { validateJob } from "../api/jobs";
import AdminOpCard from "../components/AdminOpCard";
import ArtistNameReviewPage from "./ArtistNameReviewPage";
const ADMIN_TABS = [
  {
    id: "albums",
    label: "Album Operations",
  },
  {
    id: "artists",
    label: "Artist Operations",
  },
  {
    id: "tracks",
    label: "Track Operations",
  },
  {
    id: "artist-name-review",
    label: "Artist Name Review",
  },
];
function AdminHubPage({ session, idle }) {
  const [params, setParams] = useSearchParams();
  const selected =
    ADMIN_TABS.find((tab) => tab.id === params.get("tab")) || ADMIN_TABS[0];
  const [visited, setVisited] = React.useState(new Set());
  React.useEffect(() => {
    setVisited((previous) =>
      previous.has(selected.id)
        ? previous
        : new Set([...previous, selected.id]),
    );
  }, [selected.id]);
  const selectTab = (tab) => {
    const next = new URLSearchParams(params);
    next.set("tab", tab.id);
    setParams(next);
  };
  const runOp = React.useCallback(
    async (endpoint, signal, method = "POST", options = {}) => {
      const requestOptions = {
        method,
        credentials: "include",
        signal,
      };
      if (options.body !== undefined) {
        requestOptions.body = options.body;
      }
      if (options.headers) {
        requestOptions.headers = options.headers;
      }
      const result = await requestJson(
        `${API_BASE}/admin/${endpoint}`,
        requestOptions,
      );
      if (endpoint.includes("/fetch-bpm/"))
        validateJob(
          result.data,
          /^tracks\/\d+\//.test(endpoint) ? "track" : "bpm",
        );
      return result;
    },
    [],
  );
  if (session?.role !== "admin")
    return (
      <Alert role="alert" severity="error">
        Access denied.
      </Alert>
    );
  return (
    <div className="admin-hub">
      <h2>Admin Hub</h2>
      <Tabs
        aria-label="Admin operations"
        value={selected.id}
        onChange={(_, id) => selectTab(ADMIN_TABS.find((tab) => tab.id === id))}
        selectionFollowsFocus
        variant="scrollable"
        scrollButtons="auto"
      >
        {ADMIN_TABS.map((tab) => (
          <Tab
            key={tab.id}
            id={`admin-tab-${tab.id}`}
            aria-controls={`admin-panel-${tab.id}`}
            value={tab.id}
            label={tab.label}
          />
        ))}
      </Tabs>
      {ADMIN_TABS.map((tab) => (
        <section
          key={tab.id}
          id={`admin-panel-${tab.id}`}
          role="tabpanel"
          aria-labelledby={`admin-tab-${tab.id}`}
          hidden={selected.id !== tab.id}
          tabIndex={0}
          className={
            tab.id === "artist-name-review"
              ? "admin-review-panel"
              : "admin-operation-panel"
          }
        >
          {(selected.id === tab.id || visited.has(tab.id)) &&
            (tab.id === "artist-name-review" ? (
              <ArtistNameReviewPage session={session} />
            ) : (
              <>
                {tab.id === "tracks" && <LatestBpmJob />}
                <div className="admin-ops">
                  {ADMIN_OPS.filter((op) => op.group === tab.label).map(
                    (op) => (
                      <AdminOpCard
                        key={op.key}
                        op={op}
                        runOp={runOp}
                        idle={idle || selected.id !== tab.id}
                      />
                    ),
                  )}
                </div>
              </>
            ))}
        </section>
      ))}
    </div>
  );
}
export default AdminHubPage;
